<template>
  <form-group :label="$t('challenge_goal_of_the_challenge', { challenge: challengeLabel})" required>
    <dropdown
      is-simplified
      label="Taxonomy quick search"
      :customLabel="taxonomyQuickSearchOptionLabel"
      :options="taxonomyQuickSearchOptions"
      :value-is-option="true"
      :search="true"
      @update:modelValue="handleTaxonomy"
    />
    <div class="mt-2" v-if="showActiveTaxonomies">
      <span>{{ $t('challenges_edit_active_goals') }}: </span>
      <Tag :label="taxonomy.label" v-for="taxonomy in addedTaxonomies"/>
    </div>
  </form-group>
</template>

<script>
  import Dropdown from '../../../components/Dropdown/Dropdown.vue'
  import isNumber from 'lodash/isNumber'
  import { isRelevantForActor } from '../../../util/helpers'
  import TranslationsMixin from '../../../util/TranslationsMixin'
  import ConfigMixin from '../../../util/ConfigMixin'
  import { isObject } from 'lodash'
  import RichTag from '@/components/Tag/RichTag.vue'
  import Tag from '@/components/Tag/Tag.vue'

  export default {
    name: 'TaxonomyQuickEditChallenges',
    emits: ['add-taxonomy', 'remove-taxonomy'],
    props: {
      model: Object, // Can be a challenge, actor, etc..
      showActiveTaxonomies: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      addedTaxonomies () {
        return this.taxonomyQuickSearchOptions.filter((t) => t.context.prefix === 'Remove: ')
      },
      taxonomyQuickSearchOptions () {
        var taxonomyQuickSearchOptions = []

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('activities', this.activityValuesAndLabels)]

        /*taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('membership', this.membershipValuesAndLabels)]

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('funnel_stage', this.funnelStageValuesAndLabels)]*/

        /*taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('category', this.categoryValuesAndLabels)]*/

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('stages', this.allStagesOptions)]

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('industries', this.allMainIndustriesOptions)]

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('industries', this.allSubIndustriesOptions)]

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('domains', this.allDomainsOptions)]

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('technology', this.genericTwoLevelTaxonomyOptions(this.technologies, 'technology'))]

        /*taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('product_features_a', this.genericTwoLevelTaxonomyOptions(this.productFeaturesA, 'product_features_a'))]

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('product_features_b', this.genericTwoLevelTaxonomyOptions(this.productFeaturesB, 'product_features_b'))]

        taxonomyQuickSearchOptions = [...taxonomyQuickSearchOptions, ...this.prepareTaxonomyQuickSearchOptions('product_features_c', this.genericTwoLevelTaxonomyOptions(this.productFeaturesC, 'product_features_c'))]*/

        return taxonomyQuickSearchOptions
      },
      allMainIndustriesOptions () {
        var options = []

        this.industries.forEach(i => {
          options.push({ value: { id: i.id, parent_id: null }, label: this.getLabelForTaxonomyValue('industries', i.id) })
        })

        return options
      },
      allSubIndustriesOptions () {
        var options = []

        this.industries.forEach(i => {
          if (i.industries && i.industries.length) {
            i.industries.forEach(subIndustry => {
              options.push({
                value: { id: subIndustry.id, parent_id: i.id },
                label: this.getLabelForTaxonomyValue('industries', subIndustry.id),
                parent: { id: i.id, parent_id: null }
              })
            })
          }
        })

        return options
      },
      allDomainsOptions () {
        var options = []

        this.$store.state.taxonomies.domains.forEach(domain => {
          const parentTaxonomy = {
            id: domain.id,
            name: domain.name,
            parentId: domain.domain_id,
            offers: ['service'],
            remark: domain.remark
          }

          options.push({
            value: parentTaxonomy,
            label: this.getLabelForTaxonomyValue('domains', domain.id)
          })

          if (domain.domains && domain.domains.length) {
            domain.domains.forEach(subDomain => {
              options.push({
                value: {
                  id: subDomain.id,
                  name: domain.name,
                  parentId: subDomain.domain_id,
                  offers: ['service'],
                  remark: subDomain.remark,
                  parent: parentTaxonomy
                },
                label: this.getLabelForTaxonomyValue('domains', subDomain.id)
              })
            })
          }
        })

        return options
      },
      allStagesOptions () {
        var options = []

        this.$store.state.taxonomies.stages.forEach(domain => {
          const parentTaxonomy = {
            id: domain.id,
            name: domain.name,
            parentId: domain.domain_id,
            offers: ['service'],
            remark: domain.remark
          }

          options.push({
            value: parentTaxonomy,
            label: this.getLabelForTaxonomyValue('stages', domain.id)
          })

          if (domain.domains && domain.domains.length) {
            domain.domains.forEach(subDomain => {
              options.push({
                value: {
                  id: subDomain.id,
                  name: domain.name,
                  parentId: subDomain.stage_id,
                  offers: ['service'],
                  remark: subDomain.remark,
                  parent: parentTaxonomy
                },
                label: this.getLabelForTaxonomyValue('stages', subDomain.id)
              })
            })
          }
        })

        return options
      },
      industries () {
        return this.$store.state.taxonomies.industries
      },
      productFeaturesA () {
        return this.$store.state.taxonomies.productFeaturesA
      },
      productFeaturesB () {
        return this.$store.state.taxonomies.productFeaturesB
      },
      productFeaturesC () {
        return this.$store.state.taxonomies.productFeaturesC
      },
      technologies () {
        return this.$store.state.taxonomies.technologies
      },
      categories () {
        return this.$store.state.taxonomies.categories
      }
    },
    methods: {
      isRelevantForActor,
      prepareTaxonomyQuickSearchOptions (actorTaxonomyProperty, taxonomyOptions) {
        if (!taxonomyOptions || !taxonomyOptions.length) {
          return []
        }

        // We have different approaches for values in our taxonomies unfortunately:
        // - technology, activities: [{value, label}]
        // - industries: list of industry IDs [{id, parent_id}]
        // - domains: list of domain taxonomy objects
        var options = [...taxonomyOptions].map(option => {
          var optionEnabled = false

          // Distinguish between single value actor taxonomy values and multi-value (i.e. category vs industries)
          if (!Array.isArray(this.model[actorTaxonomyProperty])) {
            optionEnabled = this.model[actorTaxonomyProperty] && this.model[actorTaxonomyProperty].value === option.value
          } else {
            optionEnabled = this.model[actorTaxonomyProperty] && this.model[actorTaxonomyProperty].find(taxonomyValue => {
              var outcome

              if (!taxonomyValue) {
                return
              }

              if (taxonomyValue.value && isNumber(taxonomyValue.value)) {
                outcome = option.value == taxonomyValue.value
              } else if (isNumber(taxonomyValue)) {
                outcome = option.value == taxonomyValue // industries
              }
              if (taxonomyValue.id && isNumber(taxonomyValue.id)) {
                outcome = option.value.id == taxonomyValue.id // domains
              }

              if (taxonomyValue.id && option.value) {
                outcome = taxonomyValue.id === option.value
              }

              if (taxonomyValue.id && isNumber(taxonomyValue.value)) {
                outcome = option.value.value === taxonomyValue.value
              }

              if (isObject(taxonomyValue.value) && isObject(option.value)) {
                if (taxonomyValue.value && taxonomyValue.value.id && option.value && option.value.id) {
                  outcome = option.value.id == taxonomyValue.value.id
                }
              }

              return outcome
            })
          }

          option.context = {
            taxonomy: actorTaxonomyProperty,
            prefix: (optionEnabled ? this.$t('actor_edit_taxonomy_quick_search_remove') : this.$t('actor_edit_taxonomy_quick_search_add')) + ': '
          }

          return option
        })

        return options
      },
      taxonomyQuickSearchOptionLabel (taxonomyOption) {
        return taxonomyOption.context.prefix + taxonomyOption.label
      },
      handleTaxonomy (taxonomyOption) {
        let taxonomyType = taxonomyOption.context.taxonomy
        let taxonomyValue = taxonomyOption.value

        if (typeof taxonomyValue === 'object' && taxonomyValue !== null) {
          taxonomyValue = taxonomyValue.id
        }

        if (this.model[taxonomyType]) {
          if (this.model[taxonomyType].filter((taxonomy) => {
            if (taxonomy.id) {
              return taxonomy.id === taxonomyValue
            }

            if (taxonomy.value) {
              if (isObject(taxonomy.value)) {
                if (taxonomy.value.id) {
                  return taxonomy.value.id === taxonomyValue
                }

                return taxonomy.value.value === taxonomyValue
              }

              return taxonomy.value === taxonomyValue
            }

            if (taxonomy.value.id) {
              return taxonomy.value.id === taxonomyValue
            }
          }).length > 0) {
            this.$emit('remove-taxonomy', taxonomyOption)
            return
          }
        }

        this.$emit('add-taxonomy', taxonomyOption)
      },
      genericTwoLevelTaxonomyOptions (taxonomies, taxonomyName) {
        var options = []

        taxonomies.forEach(taxonomy => {
          const parentTaxonomy = {
            id: taxonomy.id,
            name: taxonomy.name,
            parent_id: taxonomy.parent_id,
            translations: taxonomy.translations
          }

          options.push({
            value: parentTaxonomy,
            label: this.getLabelForTaxonomyValue(taxonomyName, taxonomy.id)
          })

          if (taxonomy.children && taxonomy.children.length) {
            taxonomy.children.forEach(subTaxonomy => {
              options.push({
                value: {
                  id: subTaxonomy.id,
                  name: subTaxonomy.name,
                  parent_id: subTaxonomy.parent_id,
                  translations: subTaxonomy.translations,
                  parent: parentTaxonomy
                },
                label: this.getLabelForTaxonomyValue(taxonomyName, subTaxonomy.id)
              })
            })
          }
        })

        return options
      },
    },
    mixins: [TranslationsMixin, ConfigMixin],
    components: {
      Tag,
      RichTag,
      Dropdown
    }
  }
</script>

<style scoped>

</style>
